module.exports = __webpack_public_path__ + "static/media/so-home-poster-cy.13e0c1b0.svg";